import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getPacking } from "../../../http/api/MasterAPI";

const PackingSelect = ({ onChange, value }) => {
  const [listPacking, setListPacking] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || null);

  async function getListPacking() {
    try {
      const response = await getPacking();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          packingId: element.varCd,
          packingName: element.varValue1,
        }))
        .filter(
          (x) => x.packingName && x.packingName.trim() !== ""
        );
      setListPacking(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListPacking();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400 }}
      >
        <MenuItem key="unselected" value={null}>
          [未選択]
        </MenuItem>
        {listPacking.map((item) => (
          <MenuItem
            key={item.packingId}
            value={item.packingId}
          >
            {item.packingName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default PackingSelect;
